// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-quinn-residences -> quinn-residences-websites -> drayton-park-at-savannah-corners
// Generated: 2026-10-29T18:34:48.209Z
// Counts: 0 design, 26 content, 46 slot group, 0 collection binding, 6 section, 0 style

export const designOverrides = {};

export const contentOverrides = {
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose the layout that fits your day </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "easy-fee-guide-hero.lead": {
    "overrideType": "VALUE",
    "customValue": "<p>A simple breakdown of the fees, services, and optional costs associated with living at <span data-type=\"field-token\" data-field=\"property_name\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "easy-fee-guide-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Know your costs before you move in.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "engrain-sitemap.height": {
    "overrideType": "VALUE",
    "customValue": "1000",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.lead": {
    "overrideType": "VALUE",
    "customValue": "<p>Compare layouts, check availability, and find the space that fits how home needs to work.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "nextstep.title": {
    "overrideType": "VALUE",
    "customValue": "<p>See townhome living in person</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tourquestions.when_a": {
    "overrideType": "VALUE",
    "customValue": "<p>The scheduler shows the times you can book.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tourscheduler.widget.self_guided_tour_link": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_self_guided_tour_url"
  },
  "tourscheduler.widget.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  },
  "tourscheduler.widget.use_leads_tour_times": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Inside, your home comes with an in-unit washer and dryer, a dishwasher, efficient appliances, and a private patio. Outside, you get a resort-style pool, a playground, a dog park, and lawn care handled for you. See everything on the <a href=\"/amenities\">amenities page</a>.</p>",
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Poolside weekends, low-upkeep living</p>",
    "mappedField": null
  },
  "amenityhighlights.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Spend summer afternoons at the resort-style pool and cabanas, let the kids loose on the pond-side playground, and wind down at the lakeside pavilion or along the walking trail—all just a short stroll from your front door. See more in the <a href=\"/gallery\">gallery</a>.</p>",
    "mappedField": null
  },
  "feetable.concierge_note": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Includes bi-annual filter change, exterior pest control, 24-hour maintenance response on emergencies, and positive credit reporting.</p>",
    "mappedField": null
  },
  "floorplanshero.offer_label": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Free rent on select homes</p>",
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Spacious three- and four-bedroom rental homes in Pooler</p>",
    "mappedField": null
  },
  "interactivemapcallout.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Find your open home, street by street.</p>",
    "mappedField": null
  },
  "lifestylehighlights.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>At Drayton Park, the shared spaces fit around a regular week: afternoons at the pool, a cookout at the lakeside pavilion, an evening loop on the walking trail, and a stop at the dog park on the way home. See the full list on our <a href=\"/amenities\">amenities page</a>.</p>",
    "mappedField": null
  },
  "neighborhoodcallout.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Pooler Parkway puts weekend errands and dinners out close by, and I-16 and I-95 make the drive to the airport, Gulfstream, the ports, or downtown Savannah easy. Find more local favorites on our <a href=\"/neighborhood\">neighborhood page</a>.</p>",
    "mappedField": null
  },
  "neighborhoodcallout.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Close to Pooler Parkway and Savannah Quarters</p>",
    "mappedField": null
  },
  "petpolicy.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Cats and dogs both feel at home here, with an on-site dog park, an open event lawn, and a walking trail for daily strolls. Take a look at the full <a href=\"/pet-policy\">pet policy</a> before moving day.</p>",
    "mappedField": null
  },
  "petpolicy.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Room to roam for every pet</p>",
    "mappedField": null
  },
  "touroptions.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Walk through the Cumberland, Sapelo, and Richmond Hill homes in 3D on our <a href=\"/virtual-tours\">virtual tours</a>, then visit in person on a self-guided tour or with our leasing team.</p>",
    "mappedField": null
  },
  "virtualtourembed.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Step inside the Cumberland, Sapelo, and Richmond Hill homes with 3D walkthroughs. Pick a plan and look around every room at your own pace, then compare details on our <a href=\"/floor-plans\">floor plans</a> page.</p>",
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactdetails.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "mappedField": "",
        "customValue": "/thank-you"
      }
    }
  },
  "floorplanshero.link_fees": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/easy-fee-guide"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "floorplanshero.link_pets": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/pet-policy"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "whyquinn.pillar_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Easy access to great schools, shopping, dining, and everyday essentials."
      }
    }
  },
  "whyquinn.pillar_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Spacious layouts that blend functionality, comfort, and modern style."
      }
    }
  },
  "whyquinn.pillar_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Community-Focused Amenities"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Shared spaces designed to bring neighbors together and create lasting memories."
      }
    }
  },
  "whyquinn.pillar_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Dedicated support and personalized service for a hassle-free rental experience."
      }
    }
  },
  "whyquinn.pillar_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Energy-efficient homes built to reduce environmental impact and help lower your utility costs."
      }
    }
  },
  "amenitieslist.amenity_photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Fenced Yards"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167577/01a11675-f21a-71cb-97bf-b73670b5f69f.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of Drayton Park homes with private yards and manicured lawns"
      }
    }
  },
  "amenitieslist.amenity_photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "2-Car Garages"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba10-3902-72fb-b1c6-d34b2ca38482.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Two-story gray-sided rental home with an attached two-car garage"
      }
    }
  },
  "amenitieslist.amenity_photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Lawn Maintenance"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba10-4d1e-709d-8742-b5164b9c0a5d.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Blue two-story home with black shutters and a neatly kept front lawn"
      }
    }
  },
  "amenitieslist.amenity_photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Smart-Home Technology"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167577/01a11675-c598-7049-8d82-1fea5e075f61.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room with fireplace and sliding glass doors."
      }
    }
  },
  "amenitieslist.amenity_photo_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Pool"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167577/01a1167f-6d24-773e-ac22-22ae538303b6.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of a resort-style swimming pool with lounge chairs and a covered cabana."
      }
    }
  },
  "amenitieslist.amenity_photo_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Playground"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167577/019fba07-1dc3-72e8-9dcf-9fc63b07d995.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Playground with slides and swings overlooking a lake and houses."
      }
    }
  },
  "amenitieslist.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167577/01a1167f-5a68-708f-848e-ce3f9a44bd5f.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor swimming pool area with covered seating and palm trees."
      }
    }
  },
  "amenitygroups.community_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167577/019fba07-1dd5-74bc-81dc-8451e45566b9.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor pool area with covered seating and palm trees."
      }
    }
  },
  "amenitygroups.home_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167577/01a11676-00ee-70cb-9425-ea10a7296aff.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern kitchen with granite countertops, stainless steel appliances, and white cabinets."
      }
    }
  },
  "amenityhighlights.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167577/01a1167f-5052-748b-a64f-00e7f7286b17.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of a resort-style swimming pool with lounge chairs and cabanas at a multifamily property."
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Resort Pool"
      }
    }
  },
  "amenityhighlights.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167577/019fba07-5a12-731d-bd25-b08c6f8d3934.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Playground with slides and swings next to a pond and residential buildings."
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Playground"
      }
    }
  },
  "amenityhighlights.card_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167577/01a11675-d6bc-713c-98dc-f9a4c9171dd9.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Covered pavilion next to a lake with a wooden deck and trees."
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Lakeside Pavilion"
      }
    }
  },
  "amenityhighlights.card_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167577/019fba07-4d60-7040-b3f4-afadccabdc4d.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Parking lot with a walking path through a grassy area and trees"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Walking Trail"
      }
    }
  },
  "amenityhighlights.card_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167577/01a11675-f21a-71cb-97bf-b73670b5f69f.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of a suburban neighborhood with many houses and manicured lawns."
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Maintained Lawns"
      }
    }
  },
  "amenityhighlights.card_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167577/01a1167f-4a48-70fe-b076-6c9362a3700e.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Covered poolside cabana with shaded seating beside lounge chairs and the swimming pool."
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Shaded Cabanas"
      }
    }
  },
  "floorplanshero.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba10-1dc4-75be-9fb8-feed83a025ec.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of Drayton Park's single-family homes along winding streets in Pooler, GA"
      }
    }
  },
  "floorplanshero.photo_10": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba10-2c6b-74f7-866a-2c8e68dca010.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Residential street lined with two-story rental homes and driveways"
      }
    }
  },
  "floorplanshero.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167577/01a1167f-5052-748b-a64f-00e7f7286b17.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of the Drayton Park community pool with lounge chairs and shaded cabanas"
      }
    }
  },
  "floorplanshero.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167577/01a11675-da39-772b-b8f9-e8b844a590f3.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Open-concept living and kitchen area with hardwood floors and a kitchen island."
      }
    }
  },
  "floorplanshero.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167577/01a11675-eaba-74da-94d8-75d233d62655.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior of a blue two-story house with a white garage door and black shutters."
      }
    }
  },
  "floorplanshero.photo_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167577/01a11675-c4bb-706f-8f4a-5cf3d31ecb2a.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern kitchen with white cabinets, quartz countertops, stainless steel appliances, and a large island."
      }
    }
  },
  "floorplanshero.photo_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba10-2cfd-7085-90f3-c30b959c985f.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Covered community pavilion beside the lake with a wooden dock"
      }
    }
  },
  "floorplanshero.photo_7": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167577/019fba07-5a12-731d-bd25-b08c6f8d3934.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Playground with slides and swings next to a pond and residential buildings."
      }
    }
  },
  "floorplanshero.photo_8": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167577/01a11675-d2ec-77b7-b4ac-ba2bac758482.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Spacious living room with vaulted ceilings and sliding glass doors leading to a patio."
      }
    }
  },
  "floorplanshero.photo_9": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167577/01a1167f-5a68-708f-848e-ce3f9a44bd5f.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor swimming pool area with covered seating and palm trees."
      }
    }
  },
  "lifestylehighlights.highlight_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Poolside afternoons"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "The resort-style pool has lounge chairs, covered cabanas for shade, and palm trees that make a Pooler summer afternoon easy to enjoy."
      }
    }
  },
  "lifestylehighlights.highlight_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Lakeside gatherings"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Neighbors meet at the covered pavilion by the lake, the grill area, the event lawn, and the playground beside the pond."
      }
    }
  },
  "lifestylehighlights.highlight_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Room to focus"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "With three or four bedrooms, a spare room can become a quiet home office, and the walking trail is close by when you need a midday reset."
      }
    }
  },
  "neighborhoodcallout.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/01a086ad-5468-71bd-a862-aca88bd8feea.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Tom Triplett Community Park in Pooler, with its stocked fishing lake"
      },
      "caption": {
        "type": "GENERATOR",
        "generatedValue": "Tom Triplett Community Park"
      }
    }
  },
  "petpolicy.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167577/01a1167f-5101-734c-a44d-5ccaf2d7d951.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Signage indicating directions to Dog Park, Event Lawn, and Walking Trail"
      },
      "caption": {
        "type": "GENERATOR",
        "generatedValue": "Dog park & trail"
      }
    }
  },
  "propertyoverview.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba10-2c6b-74f7-866a-2c8e68dca010.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Street of two-story single-family rental homes with driveways and maintained lawns at Drayton Park"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Neighborhood Streets"
      }
    }
  },
  "propertyoverview.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167577/01a11675-d6bc-713c-98dc-f9a4c9171dd9.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Covered pavilion next to a lake with a wooden deck and trees."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Lakeside Pavilion"
      }
    }
  },
  "propertyoverview.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167577/01a11675-da39-772b-b8f9-e8b844a590f3.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Open-concept living and kitchen area with hardwood floors and a kitchen island."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Open-Concept Living"
      }
    }
  },
  "propertyoverview.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167577/019fba07-5a12-731d-bd25-b08c6f8d3934.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Playground with slides and swings next to a pond and residential buildings."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Playground"
      }
    }
  },
  "propertyoverview.photo_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba10-4d41-75f8-a071-5d89b3acad7e.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "A kitchen with white cabinets and granite countertops."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Granite Kitchen"
      }
    }
  },
  "propertyoverview.photo_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167577/01a11676-01f0-728c-a3fc-8e79c28b5a6b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior of a two-story house with a dark front door, a large white garage door, and blue siding."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Home Exterior"
      }
    }
  },
  "reviewthemes.chip_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Responsive staff"
      },
      "signal": {
        "type": "GENERATOR",
        "generatedValue": "I actually can speak to someone"
      }
    }
  },
  "tourhero.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167577/019fba10-3823-76fb-95ce-c588951b738a.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Two-story rental home with blue siding, a white two-car garage door and a black front door at Quinn Residences at Drayton Park"
      }
    }
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "perq-floor-plan",
      "blockId": "perq-floor-plan",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
